import React from 'react'
import { FormConfiguration } from '../configuration'
import SelectInput from './SelectInput'
import styles from './Selectors.module.sass'

export default function Selectors() {
    return (
        <div className={styles.root} >
            <SelectInput
                label='Paese'
                name='paese'
                menuItems={FormConfiguration.paesi}
            />
            <SelectInput
                label='Citta'
                name='citta'
                menuItems={FormConfiguration.citta}
            />
            <SelectInput
                label='CAP'
                name='cap'
                menuItems={FormConfiguration.cap}
            />
        </div>
    )
}
